<template>
  <a-spin size="small" :spinning="loading"/>
  <div class="mr cp type1" @click="($event) => {
    if(!loading) click($event)
  }">{{ label }}</div>
</template>
<script lang="tsx" setup>
defineProps({
  label: {
    type: String,
    default: '未配置'
  },
  loading: {
    type: Boolean,
    default: false
  },
  click: {
    type: Function,
    default: () => {}
  }
})
</script>
<style scoped>
.type1{
  cursor: pointer;
  color: red
}
</style>
